import React, { useState, useEffect } from "react";
import DashboardLayout from "../DashboardLayout";
import { useNavigate } from "react-router-dom";
import {
  fetchBannersData,
  getHomePageData,
} from "../../services/axios/apiManager";
import { handleErrors } from "../../services/dataManager";
import { useAppContext } from "../../services/context";
import HomePageList from "./bannersList";
import HomeBannerList from "./bannersList";

function Home_Banner() {
  const { state } = useAppContext();
  const { permissions } = state;
  const navigate = useNavigate();
  const [banners, setBanners] = useState([]);
  const [granted, setGranted] = useState([]);
  const extractPermissions = () => {
    const extracted = permissions?.filter(
      (perms) => perms.module === "Home_Banners",
    );
    if (extracted) {
      setGranted(extracted);
    }
  };

  const getData = async () => {
    const res = await fetchBannersData();
    if (res?.data?.success && res?.data?.data) {
      setBanners(res.data.data);
    } else {
      handleErrors(res, navigate);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <DashboardLayout>
      <div data-testid="home-banner">
        <div className="row">
          <div className="col-12 mb-3">
            <div className="page-title-box d-sm-flex">
              <div className="page-title-right">
                <ol className="breadcrumb m-0">
                  <li className="breadcrumb-item">
                    <a>Management</a>
                  </li>
                  <li
                    className="breadcrumb-item active"
                    style={{ color: "#8b8b8cbf" }}
                  >
                    Home Banners
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </div>
        <HomeBannerList
          banners={banners}
          setBanners={setBanners}
          getData={getData}
        />
      </div>
    </DashboardLayout>
  );
}

export default Home_Banner;
// fetchBannersData
// addNewBanner
// updatedBanner
// deleteBanner
// fetchBannerById
// toggleBannerStatus
// saveBannerBgImage